import { Link } from 'react-router-dom';

export function Privacy() {
  return (
    <div className="max-w-3xl mx-auto py-12 px-4 sm:px-6">
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-neutral-400 hover:text-white text-sm mb-8 transition-colors"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Back to search
      </Link>

      <h1 className="font-mono text-3xl sm:text-4xl font-bold text-white mb-8">
        Privacy
      </h1>

      <div className="prose prose-invert prose-neutral max-w-none space-y-8">
        <p className="text-lg text-neutral-300 leading-relaxed">
          We're not interested in tracking you across the internet. Here's what we actually do.
        </p>

        <section>
          <h2 className="font-mono text-xl font-bold text-orange-500 mb-4">What We Collect</h2>
          <ul className="list-disc list-inside text-neutral-400 space-y-2">
            <li>
              <strong className="text-neutral-300">Your queries</strong> — We store search queries
              temporarily to improve results and cache responses. We don't tie them to your identity.
            </li>
            <li>
              <strong className="text-neutral-300">Basic analytics</strong> — Page views, button clicks,
              general usage patterns. We use Cloudflare Analytics which doesn't use cookies and doesn't
              track individuals.
            </li>
            <li>
              <strong className="text-neutral-300">Affiliate clicks</strong> — When you click a product
              link, we log which product was clicked so we know what's useful.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="font-mono text-xl font-bold text-orange-500 mb-4">What We Don't Do</h2>
          <ul className="list-disc list-inside text-neutral-400 space-y-2">
            <li>Sell your data to third parties</li>
            <li>Use tracking cookies to follow you around the web</li>
            <li>Require you to create an account</li>
            <li>Build advertising profiles about you</li>
          </ul>
        </section>

        <section>
          <h2 className="font-mono text-xl font-bold text-orange-500 mb-4">Cookies</h2>
          <p className="text-neutral-400">
            We use minimal cookies for site functionality. No third-party tracking cookies.
            No cookie consent popups because we don't need them — we're not doing anything
            that requires your consent.
          </p>
        </section>

        <section>
          <h2 className="font-mono text-xl font-bold text-orange-500 mb-4">Affiliate Links & Amazon Associates</h2>
          <p className="text-neutral-400 mb-4">
            NFA is a participant in the Amazon Services LLC Associates Program, an affiliate advertising
            program designed to provide a means for sites to earn advertising fees by advertising and
            linking to Amazon.co.uk and affiliated sites.
          </p>
          <p className="text-neutral-400 mb-4">
            We also participate in affiliate programs with other outdoor retailers including Cotswold Outdoor,
            Alpkit, Decathlon, Ultralight Outdoor Gear, and Trekitt.
          </p>
          <p className="text-neutral-400">
            <strong className="text-neutral-300">Important:</strong> Our product recommendations are never
            influenced by affiliate commission rates. We recommend gear based on quality, value, and
            suitability — not which retailer pays us the most.
          </p>
        </section>

        <section>
          <h2 className="font-mono text-xl font-bold text-orange-500 mb-4">Third-Party Cookies</h2>
          <p className="text-neutral-400 mb-4">
            When you click affiliate links, you'll be taken to retailer sites (Amazon, Cotswold, etc.)
            which have their own privacy policies. These retailers may place cookies on your device to
            track the referral.
          </p>
          <p className="text-neutral-400">
            We cannot control what third parties do, but we partner with reputable retailers.
            You can manage cookie preferences through your browser settings.
          </p>
        </section>

        <section className="border-t border-neutral-800 pt-8">
          <p className="text-neutral-500 text-sm">
            Questions about data privacy?{' '}
            <a href="mailto:laurence@notfuckingabout.com" className="text-orange-500 hover:text-orange-400">
              laurence@notfuckingabout.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
